import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 8px;
  margin: 0;
  width: fit-content;
  max-width: 100%;
  min-height: 26px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #ffffff 0%,
    #fceeff 10.5%,
    #fceeff 88.5%,
    #ffffff 100%
  );
  box-sizing: border-box;
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${theme.greyText};
  text-align: center;
  white-space: nowrap;
`;

export const Icon = styled.img`
  width: 6px;
  height: 6px;
  flex-shrink: 0;
`;

export const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6f3fd6;
  flex-shrink: 0;
`;
